import { IConsentConfiguration, ILatestVersion } from './ConsentService';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export interface IVehicleSpecificConsentResponse {
    readonly consentsGiven: boolean;
}

export class ConsentClient {

    private readonly headers: HeadersInit = {
        'Content-Type': 'application/json',
    }

    private readonly resourceHostId: string;

    private readonly resourceProxyId: string;

    private getGdcType = (isWcar: boolean) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;

    constructor(private readonly consentConfiguration: IConsentConfiguration, private readonly authService: IAuthServiceV2, private readonly stage: string) {
        this.resourceHostId = `myvw-consent-${stage}`;
        this.resourceProxyId = `myvw-vehicle-consent-proxy-${stage}`;
    }

    public async getVehicleSpecificConsent(vin: string, isWcar: boolean): Promise<IVehicleSpecificConsentResponse> {
        const url = `consent/v2/users/__userId__/vehicles/${vin}?gdc=${this.getGdcType(isWcar)}&client=__aud__&scopes=openid`;
        const response = await this.authService.get(this.resourceHostId, url);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json();
    }

    public async storeVehicleSpecificConsent(vin: string,  isWcar: boolean): Promise<void> {
        const url = `consents/${vin}?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authService.post(this.resourceProxyId, url, undefined, this.headers);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }

    public async storeConsentForMajorVersion(majorVersion: number, isWcar: boolean): Promise<void> {
        const url = `consent/v2/legal-text-consents/${this.consentConfiguration.appName}/__userId__/${this.consentConfiguration.termsAndConditionsTextId}/${this.consentConfiguration.countryCode}?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authService.post(this.resourceHostId, url,
            JSON.stringify({majorVersion, language: this.consentConfiguration.language}), this.headers);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }

    public async getLatestVersion(isWcar: boolean): Promise<ILatestVersion> {
        const url = `consent/v3/legal-text-consents/${this.consentConfiguration.appName}/__userId__/${this.consentConfiguration.termsAndConditionsTextId}/${this.consentConfiguration.countryCode}/${this.consentConfiguration.language}/details?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authService.get(this.resourceHostId, url);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        const data = await response.json();
        return data.latestVersion;
    }
}